import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { Row, Col, Spin, Card } from "antd";
import { useAuth } from "../Context";
import { firestore } from "../../firebase";
import VerCapacitacion from "./VerCapacitacion";
import NoPermisos from "../NoPermisos";
import Title from "antd/es/typography/Title";
import { collection, onSnapshot } from "firebase/firestore";

const Procedimientos = () => {
  const { currentUser, role, sucursal, permisos, isAdmin, loading } = useAuth();
  const [employeeData, setEmployeeData] = useState({ puesto: "", areas: [] });
  const [procedimientos, setProcedimientos] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!currentUser) return;

    const unsubscribe = firestore
      .collection("sucursal")
      .doc(sucursal)
      .collection("empleado")
      .doc(currentUser.uid)
      .onSnapshot(
        (doc) => {
          if (doc.exists) {
            const data = doc.data();
            setEmployeeData({
              puesto: data.puesto || "",
              areas: data.areas || [],
            });
          }
        },
        (error) => {
          console.error("Error getting document:", error);
        }
      );

    return () => unsubscribe();
  }, [currentUser, role, sucursal]);

  useEffect(() => {
    if (!employeeData.puesto && employeeData.areas.length === 0) return;
  
    const unsubscriptions = [];
  
    const fetchProcedimientos = async () => {
      try {
        // Consultar procedimientos del puesto
        if (employeeData.areas.length > 0) {
          for (const area of employeeData.areas) {
            const areaRef = collection(
              firestore,
              `sucursal/${sucursal}/puesto/${employeeData.puesto}/areas/${area}/procedimiento`
            );
  
            const areaUnsub = onSnapshot(areaRef, (procSnap) => {
              const procs = procSnap.docs.map((doc) => ({
                key: doc.id,
                tipo: "norma",
                area: area.id,
                ...doc.data(),
              }));
              setProcedimientos((prevProcs) =>
                prevProcs
                  .filter((proc) => proc.area !== area.id)
                  .concat(procs).filter(item => item.estatus === 'Activo')
              );
            });
            unsubscriptions.push(areaUnsub);
          }
        } else {
          const puestoRef = collection(
            firestore,
            `sucursal/${sucursal}/puesto/${employeeData.puesto}/procedimiento`
          );
  
          const puestoUnsub = onSnapshot(puestoRef, (procSnap) => {
            const procs = procSnap.docs.map((doc) => ({
              key: doc.id,
              tipo: "norma",
              ...doc.data(),
            }));
            setProcedimientos(procs.filter(item => item.estatus === 'Activo'));
          });
          unsubscriptions.push(puestoUnsub);
        }
      } catch (error) {
        console.error("Error fetching procedimientos:", error);
      }
    };
  
    fetchProcedimientos();
  
    return () => {
      unsubscriptions.forEach((unsub) => unsub());
    };
  }, [employeeData.puesto, employeeData.areas, sucursal, isAdmin]);
  

  // Helper para saber si el objeto permisos está vacío
  const isPermisosReady = () => {
    if (isAdmin) return true;
    if (!permisos || Object.keys(permisos).length === 0) return false;
    if (!permisos.capacitacion || typeof permisos.capacitacion !== 'object') return false;
    return true;
  };

  const hasPermisoProcedimientos = isAdmin || (permisos && permisos.capacitacion && permisos.capacitacion.procedimientos);

  // Filtrar procedimientos según el texto de búsqueda
  const filteredProcedimientos = procedimientos.filter((proc) => {
    const texto = searchText.toLowerCase();
    return (
      (proc.nombre?.toLowerCase().includes(texto) || "") ||
      (proc.descripcion?.toLowerCase().includes(texto) || "")
    );
  });

  return (
    <>
      {loading || !isPermisosReady() ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
          <Spin size="large" tip="Cargando permisos..." />
        </div>
      ) : (
        hasPermisoProcedimientos ? (
          <>
            <Title level={3} className="ccg-center">
              Mis Procedimientos
            </Title>
            <Input
              placeholder="Buscar procedimiento..."
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              style={{ marginBottom: 16, maxWidth: 400 }}
              allowClear
            />
            <Row gutter={[16, 16]}>
              {filteredProcedimientos.map((procedimiento, index) => (
                <Col key={index} xs={24} sm={12} md={8} lg={6}>
                  <Card
                    size="small"
                    hoverable
                    style={{ minHeight: 180, borderRadius: 12, boxShadow: '0 2px 8px #f0f1f2', padding: 0 }}
                    bodyStyle={{ padding: 12 }}
                  >
                    <VerCapacitacion documento={procedimiento} compact />
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        ) : (
          <NoPermisos />
        )
      )}
    </>
  );
};

export default Procedimientos;
